export default {
    isLogHtmlOpen: state => state.logHtmlIsOpen,
    isLogGridOpen: state => state.logGridIsOpen,
    getLogRowActions: state => state.logRowActions,
    getLogHeaderFields: state => state.logHeaderFields,
    getLogActions: state => state.logActions
}
